import { DaVinciService } from "../DaVinciService.js";
// Da Vinci Episode List (Hub View)


export const DaVinciEpisodeList = async (seriesId) => {
    const container = document.createElement('div');
    container.className = 'min-h-screen animate-fade-in relative';
    // [FIX] Use Noto Sans KR and specific Davinci background variable
    container.style.fontFamily = "'Noto Sans KR', sans-serif";
    container.style.backgroundColor = 'var(--davinci-bg, #121212)'; // Use variable with fallback

    // Background (Improved: login.webp with overlay)
    const bg = document.createElement('div');
    // Use fixed positioning and z-index to ensure it sits behind
    bg.style.position = 'fixed';
    bg.style.top = '0';
    bg.style.left = '0';
    bg.style.width = '100%';
    bg.style.height = '100%';
    bg.style.zIndex = '0';

    bg.innerHTML = `
        <img src="/login.webp" class="w-full h-full object-cover opacity-60" alt="Background" onerror="this.parentElement.style.backgroundColor='#121212'; this.style.display='none'">
        <div class="absolute inset-0" style="background-color: rgba(0,0,0,0.7); backdrop-filter: blur(4px);"></div>
    `;
    container.appendChild(bg);

    const content = document.createElement('div');
    content.className = "relative z-10 p-8 max-w-5xl mx-auto text-gray-100"; // Ensure text color is light
    container.appendChild(content);

    // Load Series Info
    const seriesRes = await DaVinciService.loadSeries(seriesId);
    if (!seriesRes.success) {
        content.innerHTML = `<div class="text-center py-20 text-red-400">${window.locale.t('common.error')}</div>`;
        return container;
    }
    const series = seriesRes.data;

    // Header w/ Back Button
    const header = document.createElement('div');
    header.className = "flex justify-between items-center mb-10";
    header.innerHTML = `
        <div class="flex items-center gap-4">
             <button id="btn-back" class="text-gray-400 hover:text-white transition-colors flex items-center gap-1">
                <span class="material-symbols-outlined text-3xl">arrow_back</span>
             </button>
             <div>
                <h1 class="text-2xl font-bold text-white mb-1">${series.title}</h1>
                <p class="text-gray-400 text-sm">${window.locale.t('davinci.episode_management')}</p>
            </div>
        </div>
        <button id="btn-new-episode" class="bg-amber-600 hover:bg-amber-500 text-white font-bold py-2 px-6 rounded-lg transition-all flex items-center gap-2 shadow-lg">
            <span class="material-symbols-outlined">post_add</span>
            ${window.locale.t('davinci.create_new_episode')}
        </button>
    `;
    content.appendChild(header);
    header.querySelector('#btn-back').onclick = () => window.router.navigate('/davinci');

    // Stats / Info Card? (Optional)

    // Episode List Container
    const listContainer = document.createElement('div');
    listContainer.className = "space-y-4";
    content.appendChild(listContainer);

    // Logic to Load Episodes
    const loadEpisodes = async () => {
        listContainer.innerHTML = `<div class="text-center text-gray-400 py-10"><span class="animate-spin inline-block">⏳</span> ${window.locale.t('common.loading')}</div>`;
        const episodes = await DaVinciService.listEpisodes(seriesId);
        listContainer.innerHTML = '';

        if (episodes.length === 0) {
            listContainer.innerHTML = `
                <div class="text-center py-16 bg-black/40 border border-gray-700 rounded-lg">
                    <p class="text-gray-400 mb-4">${window.locale.t('davinci.no_episodes')}</p>
                </div>
            `;
            return;
        }

        episodes.forEach(ep => {
            const item = document.createElement('div');
            item.className = "bg-zinc-900/80 border border-zinc-700 hover:border-amber-500/50 p-4 rounded-lg flex justify-between items-center cursor-pointer transition-all hover:bg-zinc-800";

            item.innerHTML = `
                <div class="flex items-center gap-4">
                    <div class="w-12 h-12 bg-zinc-800 rounded flex items-center justify-center text-gray-500 font-bold">
                        ${ep.order || '#'}
                    </div>
                    <div>
                        <h3 class="font-bold text-lg text-white">${ep.title || window.locale.t('editor.untitled_episode')}</h3>
                        <p class="text-xs text-gray-500">${new Date(ep.updatedAt?.seconds * 1000).toLocaleDateString(window.locale?.current || 'ko-KR', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                </div>
                <div class="flex items-center gap-3">
                    ${ep.status === 'published' ?
                    `<span class="text-xs text-green-400 border border-green-800 px-2 py-0.5 rounded backdrop-blur-md bg-green-900/30">${window.locale.t('davinci.published_badge')}</span>` :
                    `<span class="text-xs text-gray-400 border border-gray-700 px-2 py-0.5 rounded backdrop-blur-md bg-gray-800/30">${window.locale.t('davinci.draft_badge')}</span>`
                }
                    <button class="btn-edit bg-amber-600/20 text-amber-500 hover:bg-amber-600 hover:text-white px-3 py-1 rounded text-sm transition-colors">
                        ${window.locale.t('davinci.edit_btn')}
                    </button>
                </div>
            `;

            item.onclick = () => {
                window.router.navigate(`/davinci/series/${seriesId}/episode/${ep.id}`);
            };

            listContainer.appendChild(item);
        });
    };

    // New Episode Logic
    header.querySelector('#btn-new-episode').onclick = async () => {
        const title = prompt(window.locale.t('davinci.new_episode_title_prompt'), window.locale.t('editor.episode_placeholder'));
        if (!title) return;

        // Auto-calculate order (crudely)
        // ideally we get max order from list
        // For V2 MVP, just add
        const res = await DaVinciService.saveEpisode(seriesId, { title });
        if (res.success) {
            loadEpisodes(); // Reload list
        } else {
            alert(`${window.locale.t('davinci.create_fail')}: ` + res.error);
        }
    };

    loadEpisodes();

    return container;
};
